import React, { Component } from 'react';
import LoadedContent from './LoadedContent';
import { CSSTransitionGroup } from 'react-transition-group';
import TextScramble from './TextScramble';
import ContactForm from './ContactForm';
import { I18n } from 'react-redux-i18n';

class ContactPage extends Component {
  render() {
    const title = I18n.t('contact_page.title');
    const subtitle = I18n.t('contact_page.subtitle');
    const address = I18n.t('contact_page.address');
    const contacts_title = I18n.t('contact_page.contacts.title');

    return (
      <LoadedContent>
        <CSSTransitionGroup
          component="div"
          id="contact-page"
          transitionName="pageFadeInUp"
          transitionEnter={false}
          transitionLeave={false}
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div className="page-title">
            <div className="highlight">
              <TextScramble texts={[title]} />
            </div>
            <TextScramble texts={[subtitle]} />
          </div>

          <ContactForm />

          <div id="contact-footer">
            <div className="info-block">
              <div className="info-title">
                {address.title}
              </div>
              <div className="info">
                {address.line1} <br />
                {address.line2}
              </div>
            </div>

            <div className="info-block">
              <div className="info-title">
                {contacts_title}
              </div>
              <div className="info">contato@ferreri.co / +55 11 95384-2378</div>
            </div>
          </div>
        </CSSTransitionGroup>
      </LoadedContent>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/ContactPage.js